module.exports = __webpack_public_path__ + "img/fondo2.69c8bf39.jpg";